import { type SessionState } from '@ekkogmbh/apisdk';
import { atom } from 'jotai';

/**
 * Where `@ekkogmbh/apisdk` keeps the session for every tab. Its own key keeps
 * the tabs of earlier workerui versions, which renew without coordination and
 * write a logged-out session when they lose a race, from logging out the tabs
 * of this one during a rollout.
 */
export const SESSION_STORAGE_KEY = 'EKKO_WORKERUI_SESSION';

/** The state before the SDK published one, frozen like the states it publishes. */
export const loggedOut: SessionState = Object.freeze({ isAuthenticated: false });

/**
 * The app's mirror of `api.session`. `AuthGuard` writes every state the SDK
 * publishes into it; everything else only reads it.
 */
export const sessionStateAtom = atom<SessionState>(loggedOut);

// TODO: Remove once every workerui in use runs a version with the SDK owning
// the session, and these values are gone from the browsers.
const LEGACY_STORAGE_KEYS = ['EKKO_WORKERUI_AUTH', 'EKKO_WORKERUI_ANYNODEPERMISSIONS'];

/**
 * Removes what workerui stored itself before the SDK owned the session: the
 * session, refresh token included, and the permissions derived from it.
 */
export function removeLegacySessionKeys(): void {
  try {
    LEGACY_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch {
    // A browser that blocks storage stored nothing to remove.
  }
}
